const doc = [({"en":({"js":({"shared":({"table":({"row":({"order_by_dragging_is_disabled_click_to_enable":"Drag and drop is disabled. Click to reenable."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;